/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Goal = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 13V2l8 4-8 4" }],
    ["path", { d: "M20.55 10.23A9 9 0 1 1 8 4.94" }],
    ["path", { d: "M8 10a5 5 0 1 0 8.9 2.02" }]
  ]
];

export { Goal as default };
//# sourceMappingURL=goal.js.map
